/* Variant picker — keeps the surrounding product form's variant id input in sync
   with the selected option pills. Progressive enhancement: without JS the form
   still submits the first available variant. */

class VariantPicker extends HTMLElement {
  connectedCallback() {
    try {
      this.variants = JSON.parse(this.dataset.variants || '[]');
    } catch (e) {
      this.variants = [];
    }
    try {
      this.variantMedia = JSON.parse(this.dataset.variantMedia || '{}');
    } catch (e) {
      this.variantMedia = {};
    }
    this.addEventListener('change', this.onChange.bind(this));
  }

  onChange() {
    const inputs = [...this.querySelectorAll('input[type="radio"]:checked')];
    const selected = [];
    inputs.forEach((input) => {
      selected[Number(input.dataset.optionIndex)] = input.value;
    });

    const match = this.variants.find((variant) =>
      variant.options.every((value, index) => value === selected[index])
    );

    const form = this.closest('form') || document.querySelector('form[action*="/cart/add"]');
    const idInput = form && form.querySelector('input[name="id"], select[name="id"]');
    const button = form && form.querySelector('[name="add"]');

    if (match && idInput) {
      idInput.value = match.id;
      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available
          ? button.dataset.addLabel || button.textContent
          : button.dataset.soldOutLabel || 'Sold out';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }

    // Swap the product gallery to this variant's image, if it has one.
    if (match) {
      const media = this.variantMedia[match.id];
      if (media) {
        document.dispatchEvent(
          new CustomEvent('variant:media-change', {
            detail: { mediaId: media.id, src: media.src },
          })
        );
      }
    }
  }
}

if (!customElements.get('variant-picker')) {
  customElements.define('variant-picker', VariantPicker);
}
